// Deep link bewaren rond de login-redirect, zonder open redirect.
//
// Alleen een intern pad (pad + query) mag als terugkeerplek dienen: het begint met
// precies één "/", geen "//" of "/\" (protocol-relatief → andere host), geen schema
// ("javascript:", "https:") in het padgedeelte, geen backslashes of stuurtekens, en
// het moet na parsen op dezelfde origin blijven. Alles wat daar niet aan voldoet → "/".

const NEP_ORIGIN = "https://pad.invalid";
const MAX_LENGTE = 2048;

export function isVeiligInternPad(pad) {
  if (typeof pad !== "string" || pad.length === 0 || pad.length > MAX_LENGTE) return false;
  if (!pad.startsWith("/")) return false;
  if (pad.startsWith("//") || pad.startsWith("/\\")) return false;
  // Backslash, stuurtekens en spaties-trucs: browsers normaliseren "\" naar "/".
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001F\u007F]/.test(pad)) return false;
  // Geen schema in het padgedeelte (vóór ? of #); onze routes gebruiken geen ":".
  const padDeel = pad.split(/[?#]/)[0];
  if (padDeel.includes(":")) return false;
  // Laatste vangnet: na parsen nog steeds op dezelfde (nep-)origin.
  try {
    return new URL(pad, NEP_ORIGIN).origin === NEP_ORIGIN;
  } catch {
    return false;
  }
}

export function veiligInternPad(pad, terugval = "/") {
  return isVeiligInternPad(pad) ? pad : terugval;
}

// Absolute URL voor MSAL `redirectStartPage`: de huidige pagina (pad + query), mits veilig.
export function loginStartPagina(loc = window.location) {
  const pad = veiligInternPad(`${loc.pathname || "/"}${loc.search || ""}`);
  return `${loc.origin}${pad}`;
}

// Van een (absolute of relatieve) URL die MSAL na de login wil openen het interne pad
// maken. Andere origin of onveilig pad → "/".
export function internPadUitUrl(url, origin = window.location.origin) {
  if (typeof url !== "string") return "/";
  let pad = url;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) {
    if (!url.startsWith(`${origin}/`) && url !== origin) return "/";
    pad = url.slice(origin.length) || "/";
  }
  return veiligInternPad(pad);
}
